import { AddNewButton } from './AddNewButton';
import { TreeWrapper, TreeWrapperMainWrapper } from './atoms';
import { MetamodelTypeHierarchyTree } from './MetamodelTypeHierarchyTree';
import { ROOT_ID } from '../state/utils';
import { useMetamodelEditorContext } from '../state';

type MetamodelTreeProps = {
  isEditable?: boolean;
};

export const MetamodelTree = ({ isEditable }: MetamodelTreeProps) => {
  const { decomposedMetamodel } = useMetamodelEditorContext();
  const { childrenIndexes } = decomposedMetamodel;
  const rootIds = childrenIndexes[ROOT_ID] || [];
  if (!rootIds) {
    return null;
  }
  return (
    <TreeWrapperMainWrapper data-test-id="metamodel-tree">
      {rootIds.map(metamodelTypeId => (
        <TreeWrapper key={metamodelTypeId}>
          <MetamodelTypeHierarchyTree
            metamodelTypeId={metamodelTypeId}
            isEditable={isEditable}
          />
        </TreeWrapper>
      ))}
      {isEditable && <AddNewButton />}
    </TreeWrapperMainWrapper>
  );
};
